import { ChangeDetectionStrategy, Component, Input, OnInit, signal, Signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldType } from '@ngx-formly/core';
import { AlertService } from 'app/core/alert/alert.service';

@Component({
    selector: 'formly-button',
    imports: [MatIconModule],
    templateUrl: './formly-copy-button.component.html',
    styleUrl: './formly-copy-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyCopytoClipboardButtonComponent extends FieldType implements OnInit {
    icon: string;
    translocoContent: any;

    constructor(private alertService: AlertService) {
        super();
    }

    ngOnInit(): void {
        this.icon = this.field.props.icon;
        this.translocoContent = this.field.props.translocoContent;
    }

    onClick(): void {
        // Create a temporary textarea element to hold the text to be copied
        const textarea = document.createElement('textarea');
        textarea.value = this.formControl.value;

        // Append the textarea to the DOM (it needs to be in the DOM to be selectable)
        document.body.appendChild(textarea);

        // Select the text inside the textarea
        textarea.select();

        // Execute the "copy" command to copy the selected text
        document.execCommand('copy');

        // Remove the textarea element from the DOM
        document.body.removeChild(textarea);

        // Optionally, log or show a message to the user that the text was copied
        this.alertService.showAlert({
            type: 'success',
            content: this.translocoContent()['copied'],
            showIcon: true,
            title: this.translocoContent()['copy'],
        });
    }
}
